<app-header></app-header>
<div *ngIf="loading$ | async" class="loading cf-flex-row cf-justify-content-center">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>
<div *ngIf="(loading$ | async) === false" class="cf-flex-row cf-justify-content-center">
  <div *ngIf="loginEntity$ | async as loginEntity" class="cf-flex-column">
    <app-login-form [loginEntity]="loginEntity"></app-login-form>

    <p class="forgot-password"><a routerLink="/password/recover" translate>UI.Auth.ForgotPassword</a></p>
  </div>
</div>
